export type UserPreferencesSpmTabsChanged = UserPreferencesSpmTabsUpdated;

export function userPreferencesSpmTabsUpdated(visibleTabs: string[], hiddenTabs: string[]) {
  return {
    type: 'USER_PREFERENCES_SPMTABS_UPDATED' as const,
    visibleTabs,
    hiddenTabs,
  };
}

export type UserPreferencesSpmTabsUpdated = ReturnType<typeof userPreferencesSpmTabsUpdated>;

export function userPreferencesSpmTabsOrderReset() {
  return {
    type: 'USER_PREFERENCES_SPMTABS_RESET' as const,
  };
}

export type UserPreferencesSpmTabsOrderReset = ReturnType<typeof userPreferencesSpmTabsOrderReset>;
